import { stringify } from "qs";
import newRequest, { buildBaseURL } from "./newRuequest";

const getPrefix = () => "course";
const getVersion = () => "v1";

export const batchUpDownAlbums = async (albumIds, status, token) => {
  const url = buildBaseURL(getVersion(), getPrefix()) + "merchant/course/albums/batch/up-down";
  const result = await newRequest.post(url, { albums: albumIds, status }, token);
  return result?.data;
};

export const batchDeleteAlbums = async (albumIds, token) => {
  const url = buildBaseURL(getVersion(), getPrefix()) + "merchant/course/albums/batch/delete";
  const result = await newRequest.post(url, { albums: albumIds }, token);
  return result?.data;
};

export const batchSetCategoryAlbums = async (albumIds, categoryId, token) => {
  const url = buildBaseURL(getVersion(), getPrefix()) + "merchant/course/albums/batch/set-category";
  const result = await newRequest.post(
    url,
    { albums: albumIds, course_category_id: categoryId },
    token
  );
  return result?.data;
};

export const attachCoursesToAlbum = async (albumId, courseIds, token) => {
  const url =
    buildBaseURL(getVersion(), getPrefix()) + `merchant/course/album/${albumId}/attach-courses`;
  const result = await newRequest.post(url, { course_ids: courseIds }, token);
  return result?.data;
};

export const detachCoursesFromAlbum = async (albumId, courseIds, token) => {
  const url =
    buildBaseURL(getVersion(), getPrefix()) + `merchant/course/album/${albumId}/detach-courses`;
  const result = await newRequest.post(url, { course_ids: courseIds }, token);
  return result?.data;
};

export const syncCoursesToAlbum = async (albumId, courseIds, token) => {
  const url =
    buildBaseURL(getVersion(), getPrefix()) + `merchant/course/album/${albumId}/sync-courses`;
  const result = await newRequest.post(url, { course_ids: courseIds }, token);
  return result?.data;
};


